import type { UserProfile } from "../types";

export type ApiStatus = { live: boolean; mode: "live" | "demo"; user: UserProfile | null };

export async function api<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  const data = await response.json().catch(() => ({})) as T & { error?: string };
  if (!response.ok) throw Object.assign(new Error(data.error || "Не удалось выполнить запрос"), { status: response.status, data });
  return data;
}
